import { useI18n } from "../i18n/LanguageProvider";

export default function LegalPage({ pageKey }) {
  const { t } = useI18n();
  const page = t(`pages.${pageKey}`);
  const sections = Array.isArray(page?.sections) ? page.sections : [];
  return (
    <main
      className="bg-white"
      data-testid={`legal-page-${pageKey}`}
    >
      <section className="mx-auto max-w-4xl px-5 sm:px-8 lg:px-12 py-16 lg:py-24">
        <p className="text-xs font-bold tracking-widest uppercase text-[#C85A32] mb-4">
          Zelorq · Legal
        </p>
        <h1 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-900 leading-tight">
          {page?.title}
        </h1>
        <p className="mt-3 text-sm text-slate-500">{page?.updated}</p>

        <div className="mt-10 space-y-8 border-t border-[#E2E8F0] pt-10">
          {sections.map((s, i) => (
            <section key={i} data-testid={`${pageKey}-section-${i}`}>
              <h2 className="font-heading text-lg sm:text-xl font-semibold text-slate-900">
                {s.heading}
              </h2>
              <p className="mt-3 text-base text-slate-600 leading-relaxed">
                {s.body}
              </p>
            </section>
          ))}
        </div>
      </section>
    </main>
  );
}
